import React from 'react';
import { NavLink } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { headerMenuBaseUseStyles } from 'components/layout/Header/common/styles/base';
import { headerMenuMobileUseStyles } from 'components/layout/Header/common/styles/mobile';
import HeaderStore from 'stores/HeaderStore';

interface IProps {
  isDisabled: boolean;
  text?: string;
  onClick: any;
  path: string;
  Icon?: any;
}

export const HeaderMenuLink: React.FC<IProps> = ({ isDisabled, text, onClick, path, Icon }) => {
  const theme = useTheme();
  const matchesTablet = useMediaQuery(theme.breakpoints.down('sm'));
  const classesBase = headerMenuBaseUseStyles({ matchesTablet: Boolean(matchesTablet) });
  const classesMobile = headerMenuMobileUseStyles({ matchesTablet: Boolean(matchesTablet) });
  const classes = { ...classesBase, ...classesMobile };

  const handleDisableNavLinkTrickClick = (e: any) => {
    HeaderStore.isMainNavOpened && HeaderStore.toggleIsMainNavOpened();
    if (isDisabled) e.preventDefault();
    if (onClick) onClick();
  };

  return (
    <NavLink
      onClick={handleDisableNavLinkTrickClick}
      className={classes.link}
      to={{ pathname: path }}
      activeClassName={classes.linkActive}
    >
      {Icon && <Icon />}
      {text && <p style={{ marginLeft: 14 }}>{text}</p>}
    </NavLink>
  );
};
